import { createContext } from "react";
export const DeckSectionScrollContext = createContext<((offset: number) => void) | undefined>(
  undefined,
);
